var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"genpal_title"},[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('pageNotFoundTitle')))]),_c('div',{staticClass:"md-body-1"},[_vm._v(_vm._s(_vm.$t('pageNotFoundDesc')))])])}
var staticRenderFns = []

export { render, staticRenderFns }